import { useForm } from "react-hook-form";
import { useSubmitCandidateCoachingStep } from "../logic";
import { notifyBySmsModalResolver } from "../resolver";
import type { INotifyBySmsModalForm, TCandidateData } from "../types";

export const getSmsFormDefaultValues = (eligibleCandidates: readonly TCandidateData[]) => ({
  type: "",
  content: {
    text: "",
    html: "",
  },
  recipients: [...eligibleCandidates],
});

export const useSubmitSms = (
  onSubmit: (data: INotifyBySmsModalForm) => Promise<void>,
  onSuccessSMS?: () => Promise<void> | void
) => {
  const updateCandidate = useSubmitCandidateCoachingStep();

  const submitSms = async (data: INotifyBySmsModalForm) => {
    await onSubmit(data);
    await updateCandidate.submitCandidateCoachingStep(
      data.recipients.map((el) => el._id),
      data.coachingStep
    );
    if (onSuccessSMS) {
      await onSuccessSMS();
    }
  };
  return { updateSmsLoading: updateCandidate.loading, submitSms };
};

export const useNotifyBySmsModalForm = (eligibleCandidates: readonly TCandidateData[]) => {
  const { control, handleSubmit, setValue, reset, getValues } = useForm<
    INotifyBySmsModalForm,
    void,
    INotifyBySmsModalForm
  >({
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    resolver: notifyBySmsModalResolver as unknown as any,
    defaultValues: getSmsFormDefaultValues(eligibleCandidates),
  });

  return {
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
  };
};
